import { useEffect, useState } from "react";
import mainservice from "../../services/MainService";
import Spinner from "../Spinner/Spinner";
import { Getter, Setter } from "../../services/ComService";
import { IBook } from "../../DTO/BookDTO";
import { IRight } from "../../DTO/RightDTO";
import GroupsDTO from "../../DTO/GroupsDTO";
import { Edit2, Trash } from "react-feather";

enum Status {
  loading,
  loadingDone
}

type CBOptionsType = {action: string, bookId: number, clientId: number, clientName: string}
export function SendBook2ClientPage(props: {
  
}) {
  
    return <div className='booklist admin-tool'>
    <button
      onClick={() => mainservice.navTo([['view', 'adminlogin']])}
      className='secondary-button'
    >&larr; Dashboard</button>
    <SendBook2Client />
  </div>
  
}

export function SendBook2Client(props: {
  
}) {
  const [status, setStatus] = useState(Status.loading)
  const [Items] = useState(new GroupsDTO())
  const [books, setBooks] = useState<IBook[]>([])
  const [msg, setMsg] = useState('')
  const [clientId, setClientId] = useState(-1)
  const [clientName, setClientName] = useState('')
  const [version, setVersion] = useState(0)
  useEffect(() => {
    Getter('books').then((r: {books: IBook[], rights: IRight[]}) => {
      // now we got books:
      setBooks(r.books)
      Items.getFromServer().then(() => {
        // now we got groups/clients:
        setStatus(Status.loadingDone)
      })
    })
  }, [])
  return <div>
    <h1>Sende Buch an Mandant</h1>
    {
      status === Status.loading ?
      <Spinner /> : (
        status === Status.loadingDone &&
        <SelectBookAndClient
          books={books}
          clients={Items}
          cb={async (options: CBOptionsType) => {
            if (options.action === 'updateClient') {
              setClientId(options.clientId)
              setClientName(options.clientName)
              return
            }
            console.log('options', options)
            setStatus(Status.loading)
            Setter(`admin/book/send2Client`, {
              bookId: options.bookId,
              clientId: options.clientId
            }).then((data) => {
              console.log('send2Client data', data)
              setStatus(Status.loadingDone)
              setMsg(`Buch ${books.find(b => b.id === options.bookId)?.name} wurde an Mandant ${Items.getItems().find(g => g.id === options.clientId)?.name} gesendet`)
              setVersion(version + 1)
            }).catch((e) => {
              console.log('err',e)
              setMsg(e.error.message)
              setStatus(Status.loadingDone)
            })
          }}
        />
      )
    }
    <div>{msg}</div>
    <BookListByClient
      clientId={clientId}
      clientName={clientName}
      version={version}
    />
  </div>
}

function SelectBookAndClient(props: {
  books: IBook[],
  clients: GroupsDTO,
  cb: (options: CBOptionsType) => void,
}) {
  console.log('books', props.books)
  console.log('clients', props.clients)
  const [bookId, setBookId] = useState<number>(-1)
  const [clientId, setClientId] = useState<number>(-1)
  // const [clientName, setClientName] = useState('')
  return <div>
    <select
      onChange={(e) => setBookId(parseInt(e.target.value, 10))}
      defaultValue={bookId}
    >
      <option value={-1}>Buch ausw&auml;hlen</option>
      {
        props.books.map((b) => 
          <option 
            key={`book-${b.id}`}
            value={b.id}
          >[{b.id}] {b.name}</option>
        )
      }
    </select>
    <select
      onChange={(e) => {
        const clientId = parseInt(e.target.value, 10)
        setClientId(clientId)
        const clientName = props.clients.getItems().find(c => c.id === clientId)?.name || ''
        props.cb({action: 'updateClient', bookId: bookId, clientId: clientId, clientName: clientName})
      }}
      defaultValue={clientId}
    >
      <option value={-1}>Mandant ausw&auml;hlen</option>
      {
        props.clients.getItems().filter(c => c.id !== 1).map((c) => 
          <option
            key={`client-${c.id}`}
            value={c.id}
          >{c.name}</option>
        )
      }
    </select>
    {
      bookId > -1 && clientId > -1 &&
      <button
        onClick={() => {
          props.cb({action: 'send', bookId: bookId, clientId: clientId, clientName: ''})
        }}
      >Zuordnen</button>
    }
  </div>
}

function BookListByClient(props: {
  clientId: number,
  clientName: string,
  version: number,
}) {
  const [books, setBooks] = useState<IBook[]>([])
  const [status, setStatus] = useState(Status.loadingDone)
  const [clientId, setClientId] = useState(props.clientId)
  const [clientName, setClientName] = useState(props.clientName)
  async function getBooks(clientId: number) {
    Setter(`admin/books/byClient`, {
      groupId: props.clientId
    }).then((r: IBook[]) => {
      setBooks(r)
      setStatus(Status.loadingDone)
    })
  }
  useEffect(() => {
    if (props.clientId === -1) {
      return
    }
    setStatus(Status.loading)
    setClientId(props.clientId)
    getBooks(props.clientId)
  }, [props.clientId])
  useEffect(() => {
    setClientName(props.clientName)
  }, [props.clientName])
  useEffect(() => {
    getBooks(clientId)
  }, [props.version])
  function Headline () {
    return <h2>Bücher von {clientName}</h2>
  }
  if (status === Status.loading) {
    return <div>
        <Headline />
        <Spinner />
      </div>
  }
  if (books.length === 0) {
    return null
  }
  return <div>
    <Headline />
    <div>
      {
        books.map((b) => 
          <div
            key={`client-book-${b.id}`}
            className="w3-row w3-border-bottom"
          >
            <div className="w3-col s12 m6 l6 w3-padding">
              [{b.id}]{b.name}
            </div>
            <div className="w3-col s12 m6 l6">
              <button
                onClick={() => {
                  if (window.confirm(`Wollen Sie das Buch "${b.name}" beim Mandanten "${clientName}" wirklich umbennen?`)) {
                    const newName = window.prompt(`Geben Sie einen neuen Namen für das Buch "${b.name}" ein`, b.name)
                    Getter(`admin/book/${b.id}/rename/${newName}`).then(() => {
                      getBooks(clientId)
                    })
                  }
                }}
              >
                <Edit2 />
              </button>
              <button
                onClick={() => {
                  if (window.confirm(`Wollen Sie das Buch "${b.name}" beim Mandanten "${clientName}" wirklich löschen?`)) {
                    // Add logic here to handle book deletion
                    Getter(`admin/book/${b.id}/remove`).then(() => {
                      getBooks(clientId)
                    })
                  }
                }}
              >
                <Trash />
              </button>
            </div>
          </div>
        )
      }
    </div>
  </div>
}